import React, { useRef, useState, useEffect, useContext } from "react";
import { timeStringToSeconds } from "../../lib/common";
import { Context } from "../contexts/AppContext";
import { postData } from "../../lib/utils";

function VideoThumbnailExtractor(props) {
  const videoRef = useRef(null);
  const [thumbnail, setThumbnail] = useState(null);
  const { value } = useContext(Context);
  const [appState, setAppState] = value;
  const [src, setSrc] = useState("");
  

  // ✅ Use videoId as storage key
  const storageKey = props?.videodata?._id
    ? `thumb_${props.videodata._id}`
    : null;

  const MAX_LOCALSTORAGE_ITEMS = 50; // limit of thumbnails to keep

  

  // Initial source
  useEffect(() => {
    if (props?.videodata?.url) {
      //set video src path for video tag 
      setSrc(
        `${process.env.REACT_APP_VIDEO_DEST_BASE_PATH || ""}${props.videodata.url.trim()}` //video path
      );
    }
  }, [props?.videodata?.url]);

  const handleError = () => {
    console.warn("Primary video path failed. Switching to fallback...");
    setSrc(
      `${process.env.REACT_APP_VIDEO_TEST_BASE_PATH || ""}${props?.videodata?.url?.trim() || ""}`
    );
  };

  // ✅ Generate thumbnail if not found in localStorage
  useEffect(() => {

    
    const video = videoRef.current;

    if (!video || thumbnail || !props?.videodata?._id) return;

    

    //When video start playing then capture thumbnail by default
    const captureThumbnail = async () => {

      console.log(" .... capture Thumbanil .... ")
      
      try {
        video.currentTime = props?.videodata?.cuePoint
          ? timeStringToSeconds(props.videodata.cuePoint)
          : 10;

 
        await video.play().catch(err => console.warn("Play interrupted:", err));

        const drawFrame = async() => {
          const canvas = document.createElement("canvas");
         const maxWidth = 440; // thumbnails ke liye enough hai
        const aspect = video.videoHeight / video.videoWidth;
    
        canvas.width = maxWidth;
        canvas.height = maxWidth * aspect;
          const ctx = canvas.getContext("2d");
          ctx.drawImage(video, 0, 0, canvas.width, canvas.height);

          // ✅ Convert to JPEG with 0.7 quality to reduce size
          const dataUrl = canvas.toDataURL("image/jpeg", 0.7);

          //console.log("VVVVVVVVIDEO ",appState.videoArr[appState.currentVideoId].thumbnail)
          //if(!appState.videoArr[appState.currentVideoId].thumbnail)
          {
   const res1 = await  postData("videos/save-thumbnail", {
            videoId: props.videodata._id,
            image: dataUrl, // base64
            folderPath:`${appState.assetsUrl}/thumbnails`
          });
          console.log("VIDEOTHUMBNAIL EXTRACTOR saveThumbnail response ",res1)
          if(res1.success) {

         
 setAppState((prevState) => ({
  ...prevState,
  videoArr: prevState.videoArr.map((video) =>
    video._id === props.videodata._id
      ? { 
          ...video,
          thumbnail: res1.thumbnailUrl // 👈 sirf thumbnail update
        }
      : video
  ),
}));

 
           window.dispatchEvent(
  new CustomEvent("thumbnail-updated", {
    detail: {
       videoId:props.videodata._id,
      thumbnailUrl: res1.thumbnailUrl
    }
  })
); 

          }
          }

        
          
        
            
 setThumbnail(dataUrl);
         

          if (storageKey) {
            try {
              // ✅ Check if LocalStorage limit exceeded
              const keys = Object.keys(localStorage).filter(k => k.startsWith("thumb_"));
              if (keys.length >= MAX_LOCALSTORAGE_ITEMS) {
                // Remove oldest key
                console.log("REMOVE11111111111")
              //  localStorage.removeItem(keys[0]);
              }
              
              setTimeout(() => {
 //localStorage.setItem(storageKey, dataUrl);
}, 300);
            } catch (err) {
              console.warn("LocalStorage full, removing oldest item", err);
              const keys = Object.keys(localStorage).filter(k => k.startsWith("thumb_"));
              if (keys.length > 0) localStorage.removeItem(keys[0]); console.log("REMOVE333333")
                   setTimeout(() => {
 //localStorage.setItem(storageKey, dataUrl);
}, 300);
            }
          }

          video.pause();
        };

        if ("requestVideoFrameCallback" in video) {
          video.requestVideoFrameCallback(() => drawFrame());
        } else {
          setTimeout(drawFrame, 200);
        }
      } catch (err) {
        console.error("Error capturing thumbnail:", err);
      }
    };

    video.addEventListener("canplay", captureThumbnail, { once: true });
    if (video.readyState >= 3) captureThumbnail();
  }, [props?.videodata, thumbnail]);

  return (
    <div>
      <video
        ref={videoRef}
        style={{ display: "none" }}
        src={src.replace(/([^:]\/)\/+/g, "$1")}
        data-cuepoint={props?.videodata?.cuePoint || ""}
        preload="auto"
        crossOrigin="anonymous"
        muted
        playsInline
        onError={handleError}
      />

      {thumbnail && (
        <img
          className="border-2"
          id="thumbnailImage"
          src={thumbnail}
          alt="Video Thumbnail"
        />
      )}
    </div>
  );
}

export default VideoThumbnailExtractor;
